<template>
  <div class="header-page">
    <!--收拢/展开菜单-->
    <div class="switch-collapse-box contour">
      <el-button :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
                 :title="isCollapse ? '展开' : '收缩'"
                 class="collapse-btn" type="text"
                 @click="switchCollapse">
      </el-button>
    </div>
    <div class="avatar-box contour">
      <avatar-menu/>
    </div>
    <div class="nickName-box contour">
      <span>{{nickName}}</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AvatarMenu from "./components/AvatarMenu"
  export default {
    name: "HeaderPage",
    components: {AvatarMenu},
    computed: {
      ...mapGetters([
        'isCollapse'
      ]),
      nickName() {
        return this.$store.state.nickName;
      }
    },
    methods: {
      switchCollapse() {
        this.$store.commit("switchCollapse")
      }
    }
  }
</script>

<style scoped lang="scss">
  .header-page {
    box-sizing: border-box;
    height: $header-height;
    background: $header-color;
    padding: 0 20px 0 0;
    border-bottom: 1px solid transparent;
    .switch-collapse-box {
      float: left;
      margin-left: 10px;
      height: 100%;
      .collapse-btn {
        vertical-align: middle;
        font-size: 25px;
        color: #304156;
      }
    }
    .breadcrumb-box {
      margin-left: 20px;
      float: left;
      height: 100%;
    }
    .avatar-box {
      float: right;
      height: 100%;
      cursor: pointer;
    }
    .qrCode-box {
      float: right;
      height: 100%;
      margin-right: 10px;
      .qrCode {
        width: 35px;
        height: 35px;
        vertical-align: middle;
        text-align: center;
        cursor: pointer;
        padding: 0;
        border: none;
        img {
          vertical-align: middle;
        }
      }
    }
    .nickName-box {
      float: right;
      height: 100%;
      margin-right: 10px;
      span {
        color: #304156;
        vertical-align: middle;
      }
    }
  }
</style>
